import CONSTANTS from "../../assets/js/Constants"

//reducer gồm các hàm update trạng thái dựa vào kết quả từ api
const fuel_change = {}
export default function (state = fuel_change, { type, payload }) {
    switch (type) {
        case CONSTANTS.ACTION.FUEL_CHANGE.SET_FUEL_TYPE_LIST:
            return { ...state, fuelTypeList: payload }

        case CONSTANTS.ACTION.FUEL_CHANGE.SET_VEHICLES_LIST:
            return { ...state, vehiclesList: payload }

        case CONSTANTS.ACTION.FUEL_CHANGE.SET_LOCATION_LIST:
            return { ...state, locationList: payload }

        case CONSTANTS.ACTION.FUEL_CHANGE.SET_DRIVER_LIST:
            return { ...state, driverList: payload }

        case CONSTANTS.ACTION.FUEL_CHANGE.SET_VIEW_DETAIL_ACTION:
            return { ...state, viewDetail: payload }

        case CONSTANTS.ACTION.FUEL_CHANGE.SET_DELETE_FUEL_CHANGE_MESSAGE:
            return { ...state, deleteMessage: payload }

        case CONSTANTS.ACTION.FUEL_CHANGE.SET_INSERT_FUEL_CHANGE_MESSAGE:
            return { ...state, insertMessage: payload }

        case CONSTANTS.ACTION.FUEL_CHANGE.SET_UPDATE_FUEL_CHANGE_MESSAGE:
            return { ...state, updateMessage: payload }

        case CONSTANTS.ACTION.FUEL_CHANGE.UPDATE_FUEL_CHANGES_LIST:
            return { ...state, fuelChangesList: payload }

        default:
            return { ...state }
    }
}
